export default "__VITE_ASSET__BUw6xxuu__"